import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'cli-landing-footer',
  templateUrl: './landing-footer.component.html',
  styleUrls: ['./landing-footer.component.scss']
})
export class LandingFooterComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
